export const getSubtopicDetails = (store) => store.questions.subtopicDetails;

export const getQuestionLoader = (store) => store.questions.isLoading;
